"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    id: 'fashion',
    name: 'Fashion',
    background_color: '#b2b2b2',
    background_image: 'https://assets.raydiant.com/images/fashion.jpg',
    background_image_portrait: 'https://assets.raydiant.com/images/fashion-portrait.jpg',
    heading_font: 'https://fonts.raydiant.com/Righteous-Regular.woff',
    heading_text_color: '#ffffff',
    heading_2_font: 'https://fonts.raydiant.com/Righteous-Regular.woff',
    heading_2_text_color: '#00739c',
    body_font: 'https://fonts.raydiant.com/PermanentMarker-Regular.woff',
    body_text_color: '#051727',
    border_color: '#1d94c6',
};
//# sourceMappingURL=fashion.js.map


// WEBPACK FOOTER //
// ../raydiant-kit/lib/themes/fashion.js